import axios from 'axios'
import config from '../config'
import {JsonHeaders} from '../constants';

export default {
    getSourcesList() {
        return axios.get(config.publicPath + 'log-sources', {
            headers: JsonHeaders
        });
    },
    getLogEntries(data) {
    return axios.post(config.publicPath + 'log-entries', data, {
        headers: JsonHeaders
    });
}
}
